// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fragment[data-v-9d969ae2]{background-color:#f6f3e9;border-radius:2rem;padding:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
